import { cn } from '@/lib/utils'

/* Progress bar — workload on the assignment board, checklist completion on the
   handset.

   RTL: the fill must be anchored to the INLINE START — right in Arabic, left
   in English — so that a bar grows the way the language is read. Getting this
   wrong renders the Arabic fill growing from the wrong side, which reads as
   "almost done" when it means "barely started".

   `margin-inline-end: auto` is what does it: the auto margin absorbs the
   remaining space at the end, pinning the fill to the start in both
   directions. `ms-auto` is the trap — it pins the fill to the END, which is
   correct-looking in English by coincidence and wrong in Arabic. */

export function Progress(
  { value, max = 100, tone = 'var(--hk-primary)', className, label }:
  { value: number; max?: number; tone?: string; className?: string; label?: string },
) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100))
  return (
    <div
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={max}
      aria-label={label}
      className={cn('block h-1.5 overflow-hidden rounded-full bg-[#e2e8f0] dark:bg-[#334155]', className)}
    >
      <i
        className="block h-full rounded-full me-auto"
        style={{ width: `${pct}%`, background: tone }}
      />
    </div>
  )
}
